import React from "react";
import { createContext } from "react";
import { useSelector } from "react-redux";
import { createBrowserRouter } from "react-router-dom";
import { ProtectedRouters, publicRouters } from "./router";
import ItemList from "../pages/Menu/ItemList";
import ModifierCategory from "../pages/Menu/ModifierCategory";
import ItemFoodList from "../pages/Menu/ItemFoodList";

export const RouterContext = createContext();

export const CustomeRoutersProvider = ({ children }) => {
  const { token, currentUser } = useSelector((state) => state.store);
  let delivery_business = "Ecommerce";
  if (currentUser?.delivery_business) {
    delivery_business = currentUser?.delivery_business?.name;
  }

  let privateRouters = [];
  if (token) {
    const pecomPoductMenu = [
      {
        path: "menu/item-list",
        element: <ItemList />,
      },
    ];
    const foodProductMenu = [
      {
        path: "menu/item-food-list",
        element: <ItemFoodList />,
      },
      {
        path: "menu/modifier-group",
        element: <ModifierCategory />,
      },
    ];
    const productMenu =
      delivery_business === "Ecommerce" ? pecomPoductMenu : foodProductMenu;
    privateRouters = ProtectedRouters.filter((d) => d.path === "store").map(
      (d) => {
        d.children = [...d.children, ...productMenu];
        return d;
      }
    );
  }
  const router = createBrowserRouter([...publicRouters, ...privateRouters]);

  return (
    <RouterContext.Provider
      value={{
        // Router
        router,
        privateRouters,
      }}
    >
      {children}
    </RouterContext.Provider>
  );
};

export default RouterContext;
